import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const TitleBar = ({
  title,
  showCreateBtn = true,
  createBtnTitle,
  createPath,
  showFilterBtn = true,
  filter = () => {},
  showBackBtn = false,
  showExcelBtn = false,
  onExcelExport = () => {},
  headerComponent,
  backPath = '/',
}) => {
  return (
    <div className='row'>
      <div className='col-12'>
        <div className='d-flex flex-column flex-md-row justify-content-center justify-content-md-between border-bottom border-white pb-2 my-3 align-items-center'>
          <div className='d-flex flex-row mt-2'>
            <i className='fad fa-list f-20 text-secondary mx-2'></i>
            <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
              {title}
            </h1>
          </div>
          <div className='d-flex flex-row align-items-center my-3 my-md-0'>
            {showFilterBtn && (
              <button
                onClick={filter}
                className='d-flex flex-row btn btn-outline-info mx-2'
              >
                <i className='fad fa-filter f-16 mx-2'></i>
                <span className='f-13'>فیلتر</span>
              </button>
            )}
            {showExcelBtn && (
              <div className='d-flex flex-row align-items-center mx-2'>
                <button
                  onClick={onExcelExport}
                  className='d-flex flex-row align-items-center btn btn-outline-info'
                  to={backPath}
                >
                  <i className='far fa-file-excel f-16 mx-2'></i>
                  <span className='f-13'>خروجی اکسل</span>
                </button>
              </div>
            )}
            {headerComponent && headerComponent}
            {showCreateBtn && (
              <Link
                className='d-flex flex-row btn btn-outline-info '
                to={createPath}
              >
                <i className='fad fa-plus f-16 mx-2'></i>
                <span className='f-13'>{createBtnTitle}</span>
              </Link>
            )}

            {showBackBtn && (
              <div className='d-flex flex-row align-items-center'>
                <Link
                  className='d-flex flex-row align-items-center text-dark'
                  to={backPath}
                >
                  <span className='f-13'>بازگشت</span>
                  <i className='far fa-chevron-left f-16 mx-2'></i>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

TitleBar.propType = {
  title: PropTypes.string,
  createBtnTitle: PropTypes.string,
  createPath: PropTypes.string,
  filter: PropTypes.func,
  showBackBtn: PropTypes.bool,
  showCreateBtn: PropTypes.bool,
  showFilterBtn: PropTypes.bool,
  showExcelBtn: PropTypes.bool,
  onExcelExport: PropTypes.func,
};

export default TitleBar;
